import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';

/**
 * Rotating social-proof toast: someone just bought the digital blueprint.
 */
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimeout: number;
    let hideTimeout: number;
    const cycle = () => {
      showTimeout = window.setTimeout(() => {
        setVisible(true);
        hideTimeout = window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % purchaseNotifications.length);
        }, 5200);
      }, 4200);
    };
    cycle();
    return () => {
      window.clearTimeout(showTimeout);
      window.clearTimeout(hideTimeout);
    };
  }, [index, dismissed]);
  const item = purchaseNotifications[index];
  const minutes = index * 3 % 11 + 2;
  return <AnimatePresence data-id="element-224" data-mp="117o4bxc1p544">
      {visible && !dismissed ? <motion.div initial={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 right-3 z-30 sm:right-auto sm:w-[340px]" role="status" aria-live="polite" data-id="element-225" data-mp="1151xy10w4vnh">
          <div className="flex items-start gap-3 rounded-2xl border border-navy/10 bg-white p-3.5 shadow-xl shadow-navy/10" data-id="element-226" data-mp="ia4uwslodkh6">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-skysoft" data-id="element-227" data-mp="s6hl3gi0hg76">
              <CheckCircle2Icon className="h-5 w-5 text-cta" aria-hidden="true" data-id="element-228" data-mp="28jy8jq9z79ns" />
            </span>

            <div className="min-w-0 flex-1" data-id="element-229" data-mp="23lwk0pts6i4x">
              <p className="text-[13px] font-extrabold leading-tight text-navy" data-id="element-230" data-mp="23l3ko9x5iuwt">
                {item.name}{' '}
                <span className="font-semibold text-navy2" data-id="element-231" data-mp="2aqxl0m8qoee7">
                  just got the Blueprint
                </span>
              </p>
              <p className="mt-0.5 truncate text-[12px] font-semibold text-navy2/70" data-id="element-232" data-mp="2kmhhb9r7tf3h">
                {item.flag} {item.country} · {minutes} min ago
              </p>
            </div>

            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-mr-1 -mt-1 rounded-full p-1.5 text-navy2/50 transition-colors duration-150 ease-out hover:bg-navy/5 hover:text-navy" data-id="element-233" data-mp="1rylls8ddtt8a">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-234" data-mp="26nhso23pd07b" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}